import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updatePickSessionPriorityFilter = {
  name: "updatePickSessionPriorityFilter" as const,
  input: z.object({
    id: zExt.objectId(),
    name: z.string().optional(),
    filters: z.array(AdvancedFilterDataSchema).optional(),
    percentage: z.number().min(0).max(100).optional(),
    position: z.number().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
